import Passwords from './Passwords';

export default Passwords;
